<div id="page-wrapper">
  <div class="container locked-page">
    <div class="row">
      <div class="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
        <div class="card locked-page-card">
          <div class="locked-page-card__icon pic__systemlock_lg"></div>
          <span
            class="
              locked-page-card__message locked-page-card__message_secondary
            "
          >
            {{ 'ls_login_account_blocked_error_message_start' | translate }}
          </span>
          <span
            class="
              locked-page-card__message locked-page-card__message_secondary
            "
          >
            {{ 'ls_login_account_blocked_error_message_phone' | translate }}
          </span>
          <span
            class="
              locked-page-card__message locked-page-card__message_secondary
            "
          >
            {{ 'ls_login_account_blocked_error_message_end' | translate }}
          </span>

          <div class="card__large-button">
            <wb-button
              [buttonSize]="'large'"
              [buttonColor]="'primary'"
              [buttonTitle]="
                'ls_login_account_blocked_reset_password_label' | translate
              "
              (onButtonClick)="resetPassword()"
            >
            </wb-button>
          </div>

          <div
            (click)="gotoLogin()"
            class="
              text text_body text_gray text_hovered text_primary
              margin-top_30px
            "
          >
            {{ l10n('returnToLogin') }}
          </div>

          <div class="locked-page-card__lang-switcher">
            <div
              [class.locked-page-card__lang_active]="locale === locales.uk"
              (click)="setLocale(locales.uk)"
              class="locked-page-card__lang"
            >
              UA
            </div>
            <div
              [class.locked-page-card__lang_active]="locale === locales.ru"
              (click)="setLocale(locales.ru)"
              class="locked-page-card__lang"
            >
              RU
            </div>
            <div
              [class.locked-page-card__lang_active]="locale === locales.eng"
              (click)="setLocale(locales.eng)"
              class="locked-page-card__lang"
            >
              EN
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
